window.addEventListener('DOMContentLoaded', function () {
    console.log('ally1 start');				 

    window.a11y = window.a11y || {};

  let lastFocusedElement = null;
  let cleanupFn = null;

  window.a11y.trapFocus = function trapFocus(container) {
    function handleKeyDown(event) {
      if (!container.contains(document.activeElement)) return;

      const focusableSelector = [
        "a[href]:not([tabindex='-1'])",
        "area[href]:not([tabindex='-1'])",
        "input:not([disabled]):not([tabindex='-1'])",
        "select:not([disabled]):not([tabindex='-1'])",
        "textarea:not([disabled]):not([tabindex='-1'])",
        "button:not([disabled]):not([tabindex='-1'])",
        "iframe:not([tabindex='-1'])",
        "[tabindex]:not([tabindex='-1'])",
        "[contentEditable=true]:not([tabindex='-1'])"
      ].join(",");

      const focusableElements = Array.from(container.querySelectorAll(focusableSelector)).filter((el) => {
        const style = window.getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        return (
          el.offsetParent !== null &&
          style.visibility !== "hidden" &&
          style.display !== "none" &&
          rect.width > 0 &&
          rect.height > 0 &&
          !el.hasAttribute("hidden")
        );
      });

      if (!focusableElements.length) return;

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  };

  window.a11y.setupModalFocus = function (triggerSelector, modalSelector, closeSelector) {
    $(document).on('click keydown', triggerSelector, function (e) {
      if (e.type === 'click' || e.key === "Enter" || e.keyCode === 13) {
        lastFocusedElement = this;
        console.log('lastFocusedElement', lastFocusedElement);

        if (e.type === 'keydown') {
          $(this).trigger('click');
        }

        setTimeout(() => {
          const $modal = $(modalSelector);
          if (!$modal.length) return;

          const $firstFocusable = $modal.find(
            'input, button, a, [tabindex]:not([tabindex="-1"])'
          ).filter(':visible').first();

          $firstFocusable.focus();

          if (typeof cleanupFn === 'function') cleanupFn();
          cleanupFn = window.a11y.trapFocus($modal[0]);
        }, 500);
      }
    });

    $(document).on('click keydown', closeSelector, function (e) {
      if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13) {
        if (typeof cleanupFn === 'function') {
          cleanupFn();
          cleanupFn = null;
        }

        setTimeout(() => {
          if (lastFocusedElement) {
            $(lastFocusedElement)
              .trigger('focus')
              .trigger('mousedown');
            lastFocusedElement = null;
          }
        }, 100);
      }
    });
  };
window.a11y.setupModalFocus('#search-modal-btn','#a11y-search-modal','#search-modal-btn');
window.a11y.setupModalFocus('.nav-icons a[href="/search"]', 'div[x-show="searchOpen"]', '.nav-icons a[href="/search"]');

    $("#tinycookie-wrapper .tinycookie-box-close").attr("aria-label", "Close");
    $(".a11y-headingLevel2").attr({
        "role": "heading",
        "aria-level": "2"
    });
    $(".a11y-headingLevel3").attr({
        "role": "heading",
        "aria-level": "3"
    });


    $("#shopify-section-template--26411595792703__feature_text_HqJgiY .font-heading.break-words.heading-effects p").attr("role", "presentation");
    $("#shopify-section-template--26411595792703__feature_text_HqJgiY .font-heading.break-words.heading-effects, #shopify-section-template--26411595792703__feature_text_p996hq .font-heading.break-words.heading-effects").attr({
        "role": "heading",
        "aria-level": "2"
    });

    $(".hero-section .splide__track").removeAttr("aria-live").removeAttr("aria-atomic");
    $(".hero-section .splide__track ul li").removeAttr("role").removeAttr("aria-label").removeAttr("aria-roledescription");
    
    $(".article-page .card ul").attr("role", "none");

    $('img[src*="Vector2.png?v=1770320381&width=60"]').attr("alt", "Talitha coffee logo");
    $('img[src*="/Section.png"]').attr("alt", "This is Hope Roasted");

    $('.collection-tabs-mobile').each(function () {
      $(this).prepend('<label>Select Category</label>');
    });

    $(".collection-tabs-mobile button.dropdown-trigger").attr({
      "aria-label": "Select Category",
      "aria-expanded": "false"
    });

    const $menu = $('.dropdown-menu');
    $menu.attr('role', 'list');
    $menu.find('button').each(function () {
      $(this).wrap('<div role="listitem"></div>');
    });

    $(".page-bankers-hill ul.grid-container-custom").attr("role", "none");


    const observer = new MutationObserver(() => {
    const closeBtn = document.querySelector('#tinycookie-wrapper .tinycookie-box-close');
        if (closeBtn) {
        closeBtn.setAttribute('aria-label', 'Close');        
        }

        $('img[src*="sticker-left.png"], img[src*="STICKER-RIGHT.png"], img[src*="Background_cd9cda0e-035c-4743-bc54-98bd87e66f63.png"], img[src*="Background.png"]').attr("alt", "");
        $('img[src*="friendly.png"]').attr("alt", "Designed by Friendly");
        $('.g-container input[id="9393-text-2"], .g-container input[id="9393-email"], .g-container input[id="9393-text"], .g-container textarea[id="9393-textarea"]').attr("aria-required", "true");
        $("#productSelectYourCoffeeStep .itemDiv.itemCardReletive .itemCard.selectCoffeeImage img").removeAttr("role");
        $('img[src*="Frame_660.png"]').attr("alt", "Coffee Shop Spotlight, inicio coffee company, want to know where you can enjoy a delicious cup of Talitha coffee");
        $("#oke-modal-title").attr({
            "role": "heading",
            "aria-level": "2"
        });
        $(".oke-w-ratingAverageModule-rating-average").attr("aria-hidden", "true");
     

        $(".okeReviews.oke-w").removeAttr("role");
        $(".okeReviews.oke-w").removeAttr("aria-label");

        $(".subscriptionContent .subscriptionOption").each(function () {
          const $text = $(this).find("h2").text().trim();
          const $h4 = $(this).find("h4");

          $(this).attr({
            role: "group",
            "aria-label": $text
          });

          $h4.attr("role", "none");
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    setTimeout(() => {
        $('img[src*="13.jpg"], img[src*="natanja-grun-X2s8GhnQmds-unsplash_9b031b3b-52ec-4815-8599-c51ad29c3479.jpg"], img[src*="Cold_Brew.png"], .mf-block-image img').attr("alt", "");
        $('img[src*="Rectangle_16.png"], img[src*="Group_33.png"], img[src*="Group_35.png"], .sc-dISoPS.dTAYdL.pf-16_.pf-color-scheme-1 .pf-c .sc-ggqHwD img').attr("alt", "");
        $('img[src*="roastery-sign_9c56ebc7-1c14-4199-ba4d-104e10072656.webp"]').attr("alt", "");
        $('img[src*="Group_16.svg"]').attr("alt", "The Daily Grind");
        $('img[src*="RT_OrganicFourColorOrganicSeal.webp"]').attr("alt", "USDA ORGANIC registered");
        $('img[src*="9_small.svg"]').attr("alt", "Talitha Coffee Hope Rosted logo");
        $("#shopify-section-template--26411595432255__custom_form_liquid_VWJqFH .wholesale-form .form-text h3").attr("role", "presentation");
        $("#flourish-header-subtitle").attr("role", "presentation");
        $(".rebuy-widget-content .primary-title").attr({
            "role": "heading",
            "aria-level": "2"
        });
      
    }, 4000);


function announce(message) {
  const $sr = $('#review-sort-announcement');
  $sr.text('');
  setTimeout(()=>{
  $sr.text(message);
  },50);
  setTimeout(()=>{
     $sr.text('');
  },2000);
};

    $(document).on('change', '#oke-sortSelect--reviews', function () {
        const $live = $('#review-sort-announcement');
            announce('Loading');
    });

    $('#shipping-dropdown').on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    $("span.author-main").each(function(){
        const $text = $(this).find("span.author-name").text().trim();
        const $img = $(this).find("img");
        $img.attr("alt", "Profie image for " + $text);
    });


    $("nav.right-links .right-menu .right-menu_item > a").attr({'aria-haspopup':'true', 'aria-expanded':'false'});
    $('.right-menu .right-menu_item').on('focusin', function () {
    $(this).addClass('submenu-open');
        $(this).children('a').attr('aria-expanded', 'true');
    });
    $('.right-menu .right-menu_item').on('focusout', function () {
    const $this = $(this);
        setTimeout(function () {
            if (!$this.is(':focus-within')) {
                $this.removeClass('submenu-open');
                $this.children('a').attr('aria-expanded', 'false');
            }
        }, 10);
    });
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            $('.right-menu .right-menu_item').removeClass('submenu-open');
            $('.right-menu .right-menu_item').children('a').attr('aria-expanded', 'false');
        }
    });

    $(".collection-tab-panel.is-active #slideshow-template--26411594055999__featured_collections_tabs_nBeYzW-").attr("aria-label", "Most Popular");
// const observerAlert = new MutationObserver(() => {
//   const msg = document.querySelector('.adev-alert.adev-alert-error');

//   if (msg && msg.textContent.trim() !== "") {
//     msg.setAttribute('role', 'alert');
//     msg.setAttribute('aria-live', 'assertive');
//     msg.focus();
//     const text = msg.textContent;
//     msg.textContent = '';
//     setTimeout(() => {
//       msg.textContent = text;
//     }, 50);
//   }
// });

observerAlert.observe(document.body, {
  childList: true,
  subtree: true
});


    console.log('ally1 end');
});